/**
 * Calculates the number of days between two Date objects.
 * The calculation is based on the difference in whole days, disregarding the time portion.
 *
 * @param {Date} start - The start date.
 * @param {Date} end - The end date.
 * @return {number} The number of full days between the start and end dates.
 */
export function getDaysBetween(start: Date, end: Date): number {
  start = new Date(start);
  end = new Date(end);

  const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const msPerDay = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate.getTime() - startDate.getTime()) / msPerDay);
}
